module.exports = __webpack_public_path__ + "static/media/aoi_dance_logoe354f94a410e75ec5974bb935e4d6060.webp";